import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.object.from-entries.js";
import { MARKETS } from '@clearscore-group/lib.config.i18n';
import { getVisitedSiteCookie, getSessionCookie, getPersonCookie, setVisitedSiteCookie, setPersonCookie, setPublisherCookie } from '@clearscore-group/lib.helpers.cookies';
import { getAnonymousId } from '@clearscore-group/lib.helpers.segment';
import getUid from '@clearscore-group/lib.helpers.uid';
import canUseDom from '@clearscore-group/lib.helpers.can-use-dom';
import getEnv from '@clearscore-group/lib.helpers.envs';
import { selectors } from '@clearscore-group/lib.redux.router';
import { actions } from '@clearscore-group/lib.redux.identity';
import { actions as actions$1 } from '@clearscore-group/lib.redux.market';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
var marketingCampaignConfig = {
  utm_source: 'utm_source',
  utm_medium: 'utm_medium',
  utm_campaign: 'utm_campaign',
  utm_term: 'utm_term',
  utm_content: 'utm_content'
};
var getMarketingUrlParams = function getMarketingUrlParams(_ref) {
  var _ref$queryParams = _ref.queryParams,
    _queryParams = _ref$queryParams === void 0 ? {} : _ref$queryParams;
  return Object.keys(_queryParams).reduce(function (values, param) {
    return _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, param, param in marketingCampaignConfig ? _queryParams[param] : undefined));
  }, {});
};
var urlContainsMarketingParams = function urlContainsMarketingParams(queryParams) {
  return Object.keys(queryParams).includes(marketingCampaignConfig.utm_source);
};

// Get value from cookie or, if no person cookie is set, get anonymous segment ID which will
// later be mapped to the user when they log in
var getUserIdentifier = function getUserIdentifier() {
  return getPersonCookie() || getAnonymousId() || getUid();
};

/**
 * Set the active market from the `market` parameter in the querystring
 * if provided to ensure tracking events are fired in the correct region
 */
var setMarketFromQuerystring = function setMarketFromQuerystring(dispatch, overrideQueryString) {
  if (!canUseDom()) {
    return;
  }
  var queryString = overrideQueryString || window.location.search;
  var qsMarket = new URLSearchParams(queryString).get('market') || '';
  if (!MARKETS.includes(qsMarket)) {
    // Invalid market passed in querystring
    return;
  }
  dispatch(actions$1.setActiveMarket(qsMarket));
};
/**
 * Initialise tracking by dispatching identity actions and saving UTM parameters from
 * the URL into a cookie to be persisted across the site
 *
 * If you're using `connected-react-router`, you need to pass the whole redux store to
 * this function so it's able to pull the query params from the state. Otherwise, you
 * can simply pass an object with the `dispatch` propery and the function will look
 * in the second argument (or window querystring) for UTM tags
 */
var index = function index(_ref2, overrideQueryString) {
  var dispatch = _ref2.dispatch,
    getState = _ref2.getState;
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    onFirstTimeVisit = _ref3.onFirstTimeVisit,
    onMarketingCampaignVisit = _ref3.onMarketingCampaignVisit;
  var isWebview = getEnv('WEBVIEW');
  // If it's a webview with injected session cookie, it's not a first time visit
  var isFirstVisit = !getVisitedSiteCookie() && (!isWebview || !getSessionCookie());
  var userIdentifier = getUserIdentifier();
  if (isFirstVisit) {
    setMarketFromQuerystring(dispatch, overrideQueryString);
    dispatch(actions.firstTimeVisit());
    onFirstTimeVisit === null || onFirstTimeVisit === void 0 ? void 0 : onFirstTimeVisit(userIdentifier);
  }

  // always set or overwrite the visited site cookie
  // extending by a year each time a user visits
  setVisitedSiteCookie(userIdentifier);
  setPersonCookie(userIdentifier);
  if (canUseDom()) {
    var queryString = overrideQueryString || window.location.search;
    var queryParams;
    if (!overrideQueryString && typeof getState === 'function') {
      // connected-react-router context with no override; select from provided store state
      queryParams = selectors.getQueryParams(getState());
    } else {
      // Use override or window querystring, and reduce search params to a key-value object
      queryParams = Object.fromEntries(new URLSearchParams(queryString).entries());
    }
    if (urlContainsMarketingParams(queryParams)) {
      setPublisherCookie(queryString);
      var marketingUrlParams = getMarketingUrlParams({
        queryParams: queryParams
      });
      dispatch(actions.trackUserCameFromMarketingSource({
        context: marketingUrlParams
      }));
      onMarketingCampaignVisit === null || onMarketingCampaignVisit === void 0 ? void 0 : onMarketingCampaignVisit(marketingUrlParams);
    }
  }
  return null;
};
export default index;